import { useMemberProfiles } from 'views/MemberProfile/useMemberProfiles'

export const useMemberProfileStatus = () => {
  const {
    memberMemberProfiles,
    memberMemberProfilesModStatus,
    memberMemberProfilesModErrors,
  } = useMemberProfiles()

  return {
    memberMemberProfiles,
    memberMemberProfilesModStatus,
    memberMemberProfilesModErrors,
  }
}
